(function () {
  function initWarrantyLanding(root) {
    if (!root) return;

    root.querySelectorAll('[data-warranty-reveal-root]').forEach(function (revealRoot) {
      var reveals = revealRoot.querySelectorAll('.reveal');
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e, i) {
            if (e.isIntersecting) {
              setTimeout(function () {
                e.target.classList.add('visible');
              }, i * 55);
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.01, rootMargin: '0px 0px 40px 0px' }
      );
      reveals.forEach(function (el) {
        io.observe(el);
      });
      /* Ensure above-the-fold reveals become visible even if IO is slow on first paint */
      requestAnimationFrame(function () {
        reveals.forEach(function (el, i) {
          if (el.classList.contains('visible')) return;
          var r = el.getBoundingClientRect();
          if (r.bottom > 0 && r.top < window.innerHeight) {
            setTimeout(function () {
              el.classList.add('visible');
            }, i * 55);
          }
        });
      });
    });

    var wrap = root.querySelector('.hero-video-wrap');
    if (wrap) {
      var video = wrap.querySelector('.hero-banner-video');
      var playBtn = wrap.querySelector('.hero-video-btn--play');
      var pauseBtn = wrap.querySelector('.hero-video-btn-pause');
      var muteBtn = wrap.querySelector('.hero-video-btn-mute');
      if (video && playBtn && pauseBtn && muteBtn) {
        function syncPlaying() {
          var playing = !video.paused && !video.ended;
          wrap.classList.toggle('is-playing', playing);
        }
        function syncMute() {
          wrap.classList.toggle('is-muted', video.muted);
          muteBtn.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
        }
        playBtn.addEventListener('click', function () {
          video.muted = false;
          var p = video.play();
          if (p && typeof p.then === 'function') {
            p.catch(function () {
              video.muted = true;
              return video.play();
            });
          }
        });
        pauseBtn.addEventListener('click', function () {
          video.pause();
        });
        muteBtn.addEventListener('click', function () {
          video.muted = !video.muted;
          syncMute();
        });
        video.addEventListener('play', syncPlaying);
        video.addEventListener('pause', syncPlaying);
        video.addEventListener('ended', syncPlaying);
        video.addEventListener('volumechange', syncMute);
        syncPlaying();
        syncMute();
      }
    }

    root.querySelectorAll('.faq-item').forEach(function (item) {
      item.addEventListener('click', function () {
        item.classList.toggle('open');
      });
    });

    var countEl = root.querySelector('.hero-customer-count');
    if (countEl) {
      var target = parseInt(countEl.getAttribute('data-target'), 10);
      if (isNaN(target)) target = 122747;
      function setVal(n) {
        countEl.textContent = n.toLocaleString('en-US');
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        setVal(target);
      } else {
        var duration = 2200;
        var start = null;
        function easeOutCubic(t) {
          return 1 - Math.pow(1 - t, 3);
        }
        function frame(now) {
          if (start === null) start = now;
          var t = Math.min((now - start) / duration, 1);
          setVal(Math.round(easeOutCubic(t) * target));
          if (t < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      }
    }

    root.querySelectorAll('.r-photo').forEach(function (img) {
      img.addEventListener('error', function () {
        var alt = img.getAttribute('alt') || '';
        var initial = alt.trim().charAt(0) || '?';
        var div = document.createElement('div');
        div.className = 'r-initials';
        div.textContent = initial;
        img.parentNode.replaceChild(div, img);
      });
    });
  }

  document.querySelectorAll('.warranty-landing').forEach(initWarrantyLanding);
})();
